import {BLOCKS, type Document} from '@contentful/rich-text-types'
import {Text} from '@primer/react-brand'

import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'
import {getHeadingTextAndId} from '@github-ui/swp-core/lib/utils/headings'

import styles from './TableofContents.module.css'

type TableOfContentsListItemsProps = {
  content: Document
  active: string | undefined
  analyticsId: string
  handleOnClick: () => void
}

type ListItemProps = Omit<TableOfContentsListItemsProps, 'content'> & {
  id: string
  text: string
}

export const TableOfContentsListItems = ({content, ...passthru}: TableOfContentsListItemsProps) => {
  const headings = content.content.filter(node => node.nodeType === BLOCKS.HEADING_2)
  return (
    <>
      {headings.map(headingNode => {
        const {id, text} = getHeadingTextAndId(headingNode)
        return <ListItem key={id} id={id} text={text} {...passthru} />
      })}
    </>
  )
}

function ListItem({id, text, analyticsId, handleOnClick, active}: ListItemProps) {
  return (
    <li key={id}>
      <a
        {...getAnalyticsEvent({
          action: text,
          tag: 'link',
          context: 'anchor_link',
          location: 'table_of_contents',
        })}
        data-ref={`table-of-contents-list-item-link-${analyticsId}-${id}`}
        href={`#${id}`}
        className={`${styles.linkButton} ${styles.tableOfContentsListItem}`}
        onClick={handleOnClick}
        aria-current={active === id ? 'location' : undefined}
      >
        <Text
          className={styles.listItemText}
          variant={active === id ? 'default' : 'muted'}
          size="100"
          weight={active === id ? 'bold' : 'normal'}
        >
          {text}
        </Text>
      </a>
    </li>
  )
}

try{ TableOfContentsListItems.displayName ||= 'TableOfContentsListItems' } catch {}
try{ ListItem.displayName ||= 'ListItem' } catch {}